import { motion, useInView } from 'framer-motion';
import { useRef } from 'react';

export const CTASection = () => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "-100px" });

  return (
    <section 
      id="api" 
      className="py-16 lg:py-20 bg-[#1E3A5F]"
      data-testid="cta-section"
    >
      <div className="section-container">
        <motion.div
          ref={ref}
          initial={{ opacity: 0, y: 20 }}
          animate={isInView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
          className="text-center max-w-3xl mx-auto"
        >
          <h2 
            className="heading-xl text-4xl sm:text-5xl lg:text-6xl xl:text-7xl text-white mb-6"
            data-testid="cta-headline"
          >
            Build on Easysend
          </h2>
          <p 
            className="text-lg lg:text-xl text-white/70 mb-12 max-w-xl mx-auto"
            data-testid="cta-subtext"
          >
            Start integrating with a regulated, transparent and globally connected payment platform.
          </p>
          
          <div 
            className="flex flex-wrap items-center justify-center gap-4"
            data-testid="cta-buttons"
          >
            <a
              href="mailto:payments@easysendservices.com?subject=Contact Easysend"
              className="inline-flex items-center justify-center px-8 py-4 text-base font-semibold bg-white text-[#1E3A5F] hover:bg-white/90 transition-colors duration-200"
              data-testid="cta-contact-button"
            >
              Contact Us
            </a>
            <a
              href="#"
              className="inline-flex items-center justify-center px-8 py-4 text-base font-semibold bg-transparent text-white border border-white/30 hover:border-white transition-colors duration-200"
              data-testid="cta-api-button"
            >
              View API
            </a>
          </div>
        </motion.div>
      </div>
    </section>
  );
};
